import { render, staticRenderFns } from "./SchoolLevelTable.vue?vue&type=template&id=20a131ee&scoped=true&"
import script from "./SchoolLevelTable.vue?vue&type=script&lang=js&"
export * from "./SchoolLevelTable.vue?vue&type=script&lang=js&"
import style0 from "./SchoolLevelTable.vue?vue&type=style&index=0&id=20a131ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a131ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSimpleTable,VTooltip})
